export enum ConfigurationTab {
    Topics = 'topics',
    Classifications = 'classifications',
    Positions = 'positions',
}
